"use strict";
/**
 * Global configuration for the generated OpenAPI client.
 *
 * Usage: import this file once in your app entry point (src/index.tsx)
 * after running `npm run api:sync` to generate src/api/.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OpenAPI_1 = require("./api/core/OpenAPI");
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("./constants");
OpenAPI_1.OpenAPI.BASE = constants_1.host;
OpenAPI_1.OpenAPI.WITH_CREDENTIALS = true;
OpenAPI_1.OpenAPI.CREDENTIALS = 'include';
OpenAPI_1.OpenAPI.HEADERS = () => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        'X-CSRFToken': js_cookie_1.default.get('csrftoken') || '',
    });
});
